import { render, staticRenderFns } from "./StaffAdd.vue?vue&type=template&id=46c5ee6a&scoped=true&"
import script from "./StaffAdd.vue?vue&type=script&lang=js&"
export * from "./StaffAdd.vue?vue&type=script&lang=js&"
import style0 from "./StaffAdd.vue?vue&type=style&index=0&id=46c5ee6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c5ee6a",
  null
  
)

export default component.exports